export default __webpack_public_path__ + "static/media/Q1.148ddf16.jpg";